export const PLACEHOLDER_HTML = {
  head: `
<style>
  body {
    margin: 0;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-family: Inter, sans-serif;
    text-align: center;
    height: 100vh;
  }
  
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 50px;
  }

  .spinner {
    display: inline-block;
    position: relative;
    width: 4rem;
    height: 4rem;
  }

  .spinner-ring {
    box-sizing: border-box;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border-radius: 50%;
    border: 4px solid #000;
    animation: spinner-frames 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #000 transparent transparent transparent;
  }

  .spinner-ring-1 {
    animation-delay: -0.45s;
  }

  .spinner-ring-2 {
    animation-delay: -0.3s;
  }

  .spinner-ring-3 {
    animation-delay: -0.15s;
  }

  @keyframes spinner-frames {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
`.trim(),
  body: `
<div class="spinner-container">
  <div class="spinner">
    <div class="spinner-ring spinner-ring-1"></div>
    <div class="spinner-ring spinner-ring-2"></div>
    <div class="spinner-ring spinner-ring-3"></div>
  </div>
</div>
`.trim(),
};
